import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SkillsComponent } from './pages/skills/skills.component';
import { AcademicsComponent } from './pages/academics/academics.component';
import { XperienceComponent } from './pages/xperience/xperience.component';
import { IntrestComponent } from './pages/intrest/intrest.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
// import { HelpComponent } from './pages/help/help.component';


const routes: Routes = [
  {path:"",redirectTo:"home",pathMatch:"full"},
  {path:"home",component:HomeComponent},
  {path:'skills',component:SkillsComponent},
  {path:'academics',component:AcademicsComponent},
  {path:'xperience',component:XperienceComponent},
  {path:'intrests',component:IntrestComponent},
  {path:'about',component:AboutComponent},
  {path:'contact',component:ContactComponent},
  // {path:'help',component:HelpComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
